/* ==========================================================================
   CLAURY – funktioner til de nye sektioner (okt. 2026)
   - Kurv: læg i kurv direkte, opdatér kurv-skuffen og åbn den
   - Minikort: farvevalg + "Tilføj"
   - Byg dit sæt (3 for 2)
   - Shop looket, faner, vandrette rækker med pile, "Læs mere"
   Ingen afhængigheder. Bruger temaets egen kurv-skuffe.
   ========================================================================== */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Penge ---------- */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '{{amount_with_comma_separator}} kr';
    cents = Math.round(Number(cents) || 0);
    function group(n, dec, thou, sep) {
      var s = (n / 100).toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? parts[0] + sep + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return group(cents, 2, ',', '.');
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Kurv ---------- */
  var Cart = {
    get: function () {
      return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' }).then(function (r) { return r.json(); });
    },
    add: function (items, open) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok || data.status) throw new Error(data.description || data.message || 'Kunde inte lägga i varukorgen');
          return data;
        });
      }).then(function () { return Cart.refresh(open !== false); });
    },
    refresh: function (open) {
      if (document.body.classList.contains('template-cart')) {
        window.location.reload();
        return Promise.resolve();
      }
      var qc = document.querySelector('[data-section-type="quick-cart"]');
      var jobs = [Cart.get()];
      if (qc && qc.dataset.sectionId) {
        jobs.push(fetch(root + 'cart?section_id=' + encodeURIComponent(qc.dataset.sectionId), { credentials: 'same-origin' }).then(function (r) { return r.text(); }));
      }
      return Promise.all(jobs).then(function (res) {
        var cart = res[0];
        if (res[1] && qc) { updateDrawer(qc, res[1]); patchDrawer(); }
        updateCounts(cart);
        document.dispatchEvent(new CustomEvent('claury:cart', { detail: { cart: cart } }));
        if (open) openDrawer();
        return cart;
      });
    }
  };

  window.CallistoCart = Cart; /* bruges af "Byg dit sæt"-siden */
  function updateDrawer(qc, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newWrap = doc.querySelector('.quick-cart__container');
    var oldWrap = qc.querySelector('.quick-cart__container');
    if (!newWrap || !oldWrap) return;
    var oldItems = oldWrap.querySelector('.quick-cart__items');
    var newItems = newWrap.querySelector('.quick-cart__items');
    if (oldItems && newItems) {
      ['.quick-cart__items', '.quick-cart__heading', '.quick-cart__footer'].forEach(function (sel) {
        var a = oldWrap.querySelector(sel), b = newWrap.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      });
    } else {
      oldWrap.innerHTML = newWrap.innerHTML;
    }
    initCards(oldWrap);
    initScrollers(oldWrap);
  }

  function updateCounts(cart) {
    var n = cart.item_count;
    // v2.8: tælleren findes ikke i HTML, når kurven var tom – så opretter vi den
    document.querySelectorAll('a.header__cart-link').forEach(function (link) {
      var host = link.querySelector('.header__icon-with-label-touch-icon') || link;
      var el = host.querySelector('.header__cart-link-count');
      if (n > 0) {
        if (!el) { el = document.createElement('span'); el.className = 'header__cart-link-count'; host.appendChild(el); }
        el.textContent = n;
      } else if (el) { el.remove(); }
      if (link.hasAttribute('data-cart-count')) link.setAttribute('data-cart-count', n);
    });
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.setAttribute('data-cart-count', n); });
    updateProgress(cart);
    syncTiles(cart);
  }

  /* v2.8: fluebenet i "Fuldend dit sæt" følger kurven – fjernes smykket, forsvinder fluebenet */
  function syncTiles(cart) {
    var ids = {}, pids = {};
    (cart.items || []).forEach(function (i) { ids[i.variant_id] = true; pids[i.product_id] = true; });
    document.querySelectorAll('[data-cl-progress] [data-cm-card]').forEach(function (card) {
      var inCart = !!ids[card.dataset.variantId] || !!pids[card.dataset.productId];
      card.classList.toggle('is-added', inCart);
      var btn = card.querySelector('[data-cm-action="add"]');
      if (btn) {
        btn.classList.toggle('is-added', inCart);
        btn.setAttribute('aria-label', inCart ? 'Ligger i varukorgen' : 'Lägg ' + (card.dataset.title || '') + ' i varukorgen');
      }
    });
  }

  var syncTimer = null;
  /* Opdaterer kun vores egne dele af kurv-skuffen (opsummering, 3 for 2, forslag),
     så temaets egne knapper i kurven ikke bliver rørt */
  function patchDrawer() {
    var qc = document.querySelector('[data-section-type="quick-cart"]');
    if (!qc || !qc.dataset.sectionId) return;
    fetch(root + 'cart?section_id=' + encodeURIComponent(qc.dataset.sectionId), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // Sikkerhed: kun hvis svaret er kurven fra dette tema (med Callistos fri fragt-felt), ellers røres intet
        if (!doc.querySelector('.cl-drawer-ship[data-cl-drawer]')) return;
        ['.cl-drawer-ship', '.cx-totals', '.cl-3for2', '.cx-upm', '.cx-upd'].forEach(function (sel) {
          var fresh = doc.querySelector(sel), old = qc.querySelector(sel);
          if (fresh && old) old.outerHTML = fresh.outerHTML;
          else if (!fresh && old) old.remove();
          else if (fresh && !old) {
            var items = qc.querySelector('.quick-cart__items');
            var box = qc.querySelector('.quick-cart__container');
            if (sel === '.cl-3for2' && items) items.insertAdjacentHTML('afterbegin', fresh.outerHTML);
            if (sel === '.cx-upm' && items) items.insertAdjacentHTML('beforeend', fresh.outerHTML);
            if (sel === '.cx-upd' && box) box.insertAdjacentHTML('beforeend', fresh.outerHTML);
          }
        });
      }).catch(function () {});
  }
  function syncFromServer() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      Cart.get().then(updateCounts).catch(function () {});
      patchDrawer();
    }, 350);
  }
  // Fanger ALLE kurvændringer – også når temaet selv fjerner/ændrer en vare i kurv-skuffen
  try {
    new PerformanceObserver(function (list) {
      list.getEntries().forEach(function (e) {
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(e.name)) syncFromServer();
      });
    }).observe({ type: 'resource', buffered: false });
  } catch (err) {}
  document.addEventListener('visibilitychange', function () { if (!document.hidden && document.querySelector('[data-cl-progress]')) syncFromServer(); });

  function openDrawer() {
    var wrapper = document.querySelector('.quick-cart__wrapper');
    if (wrapper && wrapper.classList.contains('active')) return;
    var trigger = Array.prototype.find.call(document.querySelectorAll('.header__cart-link'), function (el) {
      return el.offsetParent !== null;
    }) || document.querySelector('.header__cart-link');
    if (trigger) trigger.click();
  }

  function countJewellery(cart) {
    return (cart.items || []).reduce(function (n, i) { return (i.gift_card || i.handle === 'gaveaeske') ? n : n + i.quantity; }, 0);
  }

  function updateProgress(cart) {
    var n = countJewellery(cart);
    var inSet = n % 3;
    var T = window.ClauryText || {};
    document.querySelectorAll('[data-progress-text]').forEach(function (el) {
      var t;
      if (n === 0) t = T.set0 || 'Välj 3 smycken – det billigaste är gratis.';
      else if (inSet === 0) t = T.setDone || '3 för 2 är aktiverat i din varukorg.';
      else if (inSet === 1) t = T.set1 || 'Du har 1 i varukorgen. Lägg till 2 till – det billigaste är gratis.';
      else t = T.set2 || 'Bara 1 till – så är det billigaste gratis.';
      el.textContent = t;
    });
    document.querySelectorAll('[data-progress-steps]').forEach(function (el) {
      var filled = n === 0 ? 0 : (inSet === 0 ? 3 : inSet);
      Array.prototype.forEach.call(el.children, function (dot, i) { dot.classList.toggle('is-on', i < filled); });
    });
  }

  /* ---------- Minikort ---------- */
  function setCardVariant(card, chip) {
    card.querySelectorAll('[data-cm-variant]').forEach(function (c) {
      c.classList.toggle('is-active', c === chip);
      c.setAttribute('aria-checked', c === chip ? 'true' : 'false');
    });
    card.dataset.variantId = chip.dataset.cmVariant;
    card.dataset.price = chip.dataset.price;
    if (chip.dataset.color) card.dataset.color = chip.dataset.color;
    var price = card.querySelector('[data-cm-price]');
    if (price && chip.dataset.priceLabel) price.textContent = chip.dataset.priceLabel;
    var name = card.querySelector('[data-cm-color-name]');
    if (name && chip.dataset.color) name.textContent = chip.dataset.color;
    if (chip.dataset.imageLarge) {
      var img = card.querySelector('.cx-card__img, .cm-card__img');
      if (img) { img.removeAttribute('srcset'); img.src = chip.dataset.imageLarge; }
      card.dataset.image = chip.dataset.image || card.dataset.image;
    }
    card.dispatchEvent(new CustomEvent('cm:variant', { bubbles: true }));
  }

  function initCards(scope) {
    (scope || document).querySelectorAll('[data-cm-card]:not([data-cm-ready])').forEach(function (card) {
      card.setAttribute('data-cm-ready', '');
    });
  }

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cm-variant]');
    if (chip) {
      var card = chip.closest('[data-cm-card]');
      if (card && !chip.disabled) { e.preventDefault(); setCardVariant(card, chip); }
      return;
    }
    var btn = e.target.closest('[data-cm-action="add"]');
    if (btn) {
      e.preventDefault();
      var c = btn.closest('[data-cm-card]');
      if (!c || btn.disabled) return;
      var label = btn.querySelector('[data-cm-btn-label]');
      var original = label ? label.textContent : '';
      btn.disabled = true; btn.classList.add('is-loading');
      if (label) label.textContent = 'Lägger till…';
      // v2.6: "+" på produktsiden lægger i kurven uden at åbne kurv-skuffen
      var stayHere = !!btn.closest('[data-cl-progress], [data-no-drawer]');
      Cart.add([{ id: Number(c.dataset.variantId), quantity: 1 }], !stayHere).then(function () {
        btn.classList.remove('is-loading'); btn.classList.add('is-added');
        if (label) label.textContent = 'Tillagd';
        var card2 = btn.closest('[data-cm-card]'); if (card2) card2.classList.add('is-added');
        if (stayHere) { btn.disabled = false; return; }
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-added'); if (card2) card2.classList.remove('is-added'); if (label) label.textContent = original; }, 2200);
      }).catch(function (err) {
        btn.disabled = false; btn.classList.remove('is-loading');
        if (label) label.textContent = original;
        alert(err.message);
      });
    }
  });

  /* ---------- Byg dit sæt (v2.4) ---------- */
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function initBundle(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    var size = Number(section.dataset.size) || 3;
    var picks = [];
    var dock = section.querySelector('[data-bundle-dock]');
    function all(sel) { return section.querySelectorAll(sel); }

    function freeIndex() {
      if (picks.length !== size) return -1;
      var idx = 0;
      picks.forEach(function (p, i) { if (p.price < picks[idx].price) idx = i; });
      return idx;
    }

    function render() {
      var free = freeIndex();
      all('[data-bundle-slots]').forEach(function (list) {
        var style = list.dataset.style;
        Array.prototype.forEach.call(list.querySelectorAll('[data-slot]'), function (slot, i) {
          var p = picks[i];
          slot.classList.toggle('is-filled', !!p);
          slot.classList.toggle('is-free', i === free);
          if (style === 'row') {
            slot.innerHTML = p
              ? '<span class="cb__slot-num">' + (i + 1) + '</span>' +
                (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span class="cb__slot-img"></span>') +
                '<span class="cb__slot-info"><span class="cb__slot-name">' + esc(p.title) + '</span>' +
                '<span class="cb__slot-meta">' + (p.color ? '<span class="cb__slot-color">' + esc(p.color) + ' · </span>' : '') +
                (i === free ? '<s>' + formatMoney(p.price) + '</s> <b>Gratis</b>' : '<span>' + formatMoney(p.price) + '</span>') + '</span></span>' +
                '<button type="button" class="cb__remove" data-remove="' + i + '" aria-label="Fjern ' + esc(p.title) + '">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>'
              : '<span class="cb__slot-num">' + (i + 1) + '</span><span class="cb__slot-empty">Välj smycke ' + (i + 1) + '</span>';
          } else {
            slot.innerHTML = p
              ? (p.image ? '<img src="' + esc(p.image) + '" alt="">' : '') +
                (i === free ? '<em>Gratis</em>' : '') +
                '<button type="button" class="cb__remove" data-remove="' + i + '" aria-label="Fjern ' + esc(p.title) + '">×</button>'
              : '<span>' + (i + 1) + '</span>';
          }
        });
      });

      var sum = picks.reduce(function (n, p) { return n + p.price; }, 0);
      var cheapest = free > -1 ? picks[free].price : 0;
      var left = size - picks.length;
      var status;
      if (picks.length === 0) status = 'Välj ' + size + ' smycken – det billigaste är gratis';
      else if (left > 0) status = 'Välj ' + left + ' till' + (left === 1 ? ' – så är det billigaste gratis' : '');
      else status = 'Ditt set är klart';

      all('[data-bundle-status]').forEach(function (el) { el.textContent = status; });
      var shortStatus = picks.length === 0 ? 'Välj ' + size + ' smycken' : (left > 0 ? 'Välj ' + left + ' till' : 'Du sparar ' + formatMoney(cheapest));
      all('[data-bundle-status-short]').forEach(function (el) { el.textContent = shortStatus; });
      all('[data-bundle-count]').forEach(function (el) { el.textContent = picks.length + ' / ' + size; });
      all('[data-bundle-before]').forEach(function (el) { el.textContent = cheapest ? formatMoney(sum) : ''; });
      all('[data-bundle-save]').forEach(function (el) { el.textContent = cheapest ? 'Du sparar ' + formatMoney(cheapest) : ''; });
      all('[data-bundle-total]').forEach(function (el) { el.textContent = picks.length ? formatMoney(sum - cheapest) : '–'; });
      all('[data-bundle-cta]').forEach(function (el) {
        el.textContent = left > 0 ? (picks.length ? 'Välj ' + left + ' till' : 'Välj ' + size + ' smycken') : (section.dataset.tAdd || 'Lägg setet i varukorgen');
      });
      all('[data-bundle-cta-short]').forEach(function (el) { el.textContent = left > 0 ? left + ' till' : 'Lägg i varukorgen'; });
      all('[data-bundle-add]').forEach(function (b) { if (!b.classList.contains('is-busy')) b.disabled = picks.length !== size; });
      section.classList.toggle('is-complete', picks.length === size);
      section.classList.toggle('has-picks', picks.length > 0);

      all('[data-cm-card]').forEach(function (card) {
        var on = picks.some(function (p) { return p.card === card; });
        card.classList.toggle('is-picked', on);
        var l = card.querySelector('[data-cm-btn-label]');
        if (l) l.textContent = on ? (section.dataset.tPicked || 'Vald') : (section.dataset.tPick || 'Välj');
        var btn = card.querySelector('[data-cm-action="select"]');
        if (btn) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function pickFrom(card) {
      return { card: card, id: Number(card.dataset.variantId), price: Number(card.dataset.price), image: card.dataset.image, title: card.dataset.title, color: card.dataset.color };
    }

    section.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-remove]');
      if (rm) { e.preventDefault(); picks.splice(Number(rm.dataset.remove), 1); render(); return; }
      var pick = e.target.closest('[data-cm-action="select"], .cx-card--pick .cx-card__media');
      if (pick) {
        e.preventDefault();
        var card = pick.closest('[data-cm-card]');
        var idx = picks.findIndex(function (p) { return p.card === card; });
        if (idx > -1) { picks.splice(idx, 1); render(); return; }
        if (picks.length >= size) {
          all('[data-bundle-status]').forEach(function (el) { el.textContent = 'Ditt set är fullt – ta bort ett smycke för att välja ett annat'; });
          all('[data-bundle-status-short]').forEach(function (el) { el.textContent = 'Setet är fullt – ta bort ett först'; });
          section.classList.add('is-shake'); setTimeout(function () { section.classList.remove('is-shake'); }, 500);
          return;
        }
        picks.push(pickFrom(card));
        render();
        return;
      }
      var f = e.target.closest('[data-bundle-filter]');
      if (f) {
        var val = f.dataset.bundleFilter;
        all('[data-bundle-filter]').forEach(function (b) { b.classList.toggle('is-active', b === f); b.setAttribute('aria-pressed', b === f ? 'true' : 'false'); });
        all('.cb__item').forEach(function (it) { it.hidden = !!val && it.dataset.type !== val; });
        var grid = section.querySelector('.cb__grid');
        if (grid) { grid.scrollLeft = 0; grid.dispatchEvent(new Event('scroll')); }
        return;
      }
      var add = e.target.closest('[data-bundle-add]');
      if (add) {
        if (picks.length !== size) return;
        var buttons = all('[data-bundle-add]');
        buttons.forEach(function (b) { b.disabled = true; b.classList.add('is-busy'); });
        all('[data-bundle-cta]').forEach(function (el) { el.textContent = 'Lägger i varukorgen…'; });
        var items = {};
        picks.forEach(function (p) { items[p.id] = (items[p.id] || 0) + 1; });
        var list = Object.keys(items).map(function (id) { return { id: Number(id), quantity: items[id] }; });
        Cart.add(list).then(function () {
          all('[data-bundle-cta]').forEach(function (el) { el.textContent = 'Lagt i kurven'; });
          setTimeout(function () { buttons.forEach(function (b) { b.classList.remove('is-busy'); }); picks = []; render(); }, 1400);
        }).catch(function (err) {
          buttons.forEach(function (b) { b.classList.remove('is-busy'); });
          render(); alert(err.message);
        });
      }
    });

    section.addEventListener('cm:variant', function (e) {
      var card = e.target.closest('[data-cm-card]');
      picks.forEach(function (p, i) { if (p.card === card) picks[i] = pickFrom(card); });
      render();
    });

    render();
  }

  /* ---------- Shop looket ---------- */
  function initLook(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    function activate(i, scroll) {
      section.querySelectorAll('[data-look-dot]').forEach(function (d) { d.classList.toggle('is-active', d.dataset.lookDot === String(i)); });
      section.querySelectorAll('[data-look-item]').forEach(function (it) {
        var on = it.dataset.lookItem === String(i);
        it.classList.toggle('is-active', on);
        if (on && scroll) it.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
    }
    section.addEventListener('click', function (e) {
      var d = e.target.closest('[data-look-dot]');
      if (d) activate(d.dataset.lookDot, true);
    });
    section.querySelectorAll('[data-look-item]').forEach(function (it) {
      it.addEventListener('mouseenter', function () { activate(it.dataset.lookItem, false); });
    });
  }

  /* ---------- Faner ---------- */
  function initTabs(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = '1';
    var tabs = section.querySelectorAll('[role="tab"]');
    var panels = section.querySelectorAll('[role="tabpanel"]');
    function show(i) {
      tabs.forEach(function (t, n) { var on = n === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1; });
      panels.forEach(function (p, n) { var on = n === i; p.classList.toggle('is-active', on); p.hidden = !on; });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          show(n); tabs[n].focus();
        }
      });
    });
  }

  /* ---------- Vandrette rækker med pile ---------- */
  function initScrollers(scope) {
    (scope || document).querySelectorAll('[data-scroller]:not([data-scroller-ready])').forEach(function (el) {
      el.setAttribute('data-scroller-ready', '');
      var wrap = document.createElement('div');
      wrap.className = 'cl-scroller';
      el.parentNode.insertBefore(wrap, el);
      wrap.appendChild(el);
      ['prev', 'next'].forEach(function (dir) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cl-scroller__btn cl-scroller__btn--' + dir;
        b.setAttribute('aria-label', dir === 'prev' ? 'Föregående' : 'Nästa');
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="' + (dir === 'prev' ? 'M15 5l-7 7 7 7' : 'M9 5l7 7-7 7') + '"/></svg>';
        b.addEventListener('click', function () {
          el.scrollBy({ left: (dir === 'prev' ? -1 : 1) * el.clientWidth * 0.85, behavior: 'smooth' });
        });
        wrap.appendChild(b);
      });
      function update() {
        var max = el.scrollWidth - el.clientWidth - 2;
        wrap.classList.toggle('has-overflow', max > 0);
        wrap.classList.toggle('at-start', el.scrollLeft <= 2);
        wrap.classList.toggle('at-end', el.scrollLeft >= max);
      }
      el.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- "Læs mere" (v2.5): 2 linjer + "…" på mobil, hele teksten på desktop ---------- */
  var mqMobile = window.matchMedia('(max-width: 749px)');
  function measureClamp(el) {
    var inner = el.firstElementChild, btn = el.querySelector('[data-cl-clamp-toggle]');
    if (!inner || !btn) return;
    if (el.classList.contains('is-open')) { btn.hidden = false; return; }
    btn.hidden = !(mqMobile.matches && inner.scrollHeight > inner.clientHeight + 2);
  }
  function initClamp(scope) {
    (scope || document).querySelectorAll('[data-cl-clamp]').forEach(function (el) {
      if (!el.hasAttribute('data-ready')) {
        el.setAttribute('data-ready', '');
        var btn = el.querySelector('[data-cl-clamp-toggle]');
        if (btn) btn.addEventListener('click', function () {
          var open = el.classList.toggle('is-open');
          btn.textContent = open ? 'Visa mindre' : 'Läs mer';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (!open) measureClamp(el);
        });
      }
      measureClamp(el);
    });
  }
  window.addEventListener('resize', function () { initClamp(); });
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', function () { initClamp(); });
  window.addEventListener('load', function () { initClamp(); });

  /* ---------- Footer: foldet sammen på mobil ---------- */
  function initFooter() {
    var mq = window.matchMedia('(max-width: 749px)');
    function apply() {
      document.querySelectorAll('[data-cl-footer-col]').forEach(function (d) {
        if (mq.matches) { if (!d.dataset.touched) d.removeAttribute('open'); }
        else d.setAttribute('open', '');
      });
    }
    document.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-cl-footer-col] > summary');
      if (!s) return;
      if (!mq.matches) { e.preventDefault(); return; }   // desktop: altid åben
      s.parentNode.dataset.touched = '1';
    });
    if (mq.addEventListener) mq.addEventListener('change', apply);
    apply();
  }

  function init(scope) {
    scope = scope || document;
    initCards(scope);
    scope.querySelectorAll('[data-cl-bundle]').forEach(initBundle);
    scope.querySelectorAll('[data-cl-look]').forEach(initLook);
    scope.querySelectorAll('[data-cl-tabs]').forEach(initTabs);
    initScrollers(scope);
    initClamp(scope);
  }

  /* Hold produktsidens statuslinje opdateret, når temaet selv ændrer kurven */
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.cart) { updateProgress(e.detail.cart); syncTiles(e.detail.cart); }
    else syncFromServer();
  });

  function start() {
    init(); initFooter();
    if (document.querySelector('[data-cl-progress]')) syncFromServer();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* Temaeditoren: genstart når en sektion genindlæses */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  window.Claury = { cart: Cart, formatMoney: formatMoney, init: init };
})();

/* Callisto: anmeldelseslinjen ruller blødt ned til Judge.me-anmeldelserne */
document.addEventListener('click', function (e) {
  var a = e.target.closest && e.target.closest('a[data-cl-scroll]');
  if (!a) return;
  var id = (a.getAttribute('href') || '').replace(/^#/, '');
  var target = id && document.getElementById(id);
  if (!target && /^judgeme/.test(id)) target = document.querySelector('.jdgm-review-widget, .jdgm-widget.jdgm-review-widget, [data-judgeme-widget]');
  if (!target) {
    // Sektionen er ikke på siden: brug evt. det alternative link (fx Trustpilot)
    if (a.dataset.clFallback) { e.preventDefault(); window.open(a.dataset.clFallback, '_blank', 'noopener'); }
    return;
  }
  e.preventDefault();
  var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
  window.scrollTo({ top: y, behavior: 'smooth' });
});

/* Callisto: ønskeliste-knappen (Swish) ved "Tilføj til kurv" er altid kvadratisk – samme højde som kurv-knappen –
   og står med 8 px luft. Måles i stedet for at gætte, fordi Swish bygger sin knap selv. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var SEL = '[class*="swish" i], [class*="wishlist" i], [class*="wk-" i], [id*="swish" i], [id*="wishlist" i]';
  var busy = false;
  function fix() {
    if (busy) return; busy = true;
    try {
      var atc = document.querySelector('.product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
      if (!atc) return;
      var root = atc.closest('.product-form__controls-group--submit') || atc.closest('.product__block--buy-buttons') || atc.closest('.product__block') || atc.parentElement;
      if (!root) return;
      soldOut(atc, null, Math.round(atc.getBoundingClientRect().height) || 56);
      var wl = null;
      root.querySelectorAll(SEL).forEach(function (el) {
        if (wl || el.contains(atc) || el === atc) return;
        var p = el.parentElement, nested = false;
        while (p && p !== root) { if (p.matches && p.matches(SEL)) { nested = true; break; } p = p.parentElement; }
        if (!nested) wl = el;
      });
      if (!wl) return;
      removePh();
      /* Udsolgt: kurv-knappen er skjult (højde 0) – så bruges samme faste højde som kurv-knappen (56 px) */
      var h = Math.round(atc.getBoundingClientRect().height) || 56;
      ['width', 'height', 'min-width', 'max-width', 'min-height', 'max-height'].forEach(function (k) { wl.style.setProperty(k, h + 'px', 'important'); });
      wl.style.setProperty('flex', '0 0 ' + h + 'px', 'important');
      wl.style.setProperty('margin', '0', 'important');
      wl.style.setProperty('padding', '0', 'important');
      wl.style.setProperty('box-sizing', 'border-box', 'important');
      wl.classList.add('cl-wl-ready');
      wl.querySelectorAll('button, a').forEach(function (b) {
        b.style.setProperty('width', '100%', 'important'); b.style.setProperty('height', '100%', 'important');
        b.style.setProperty('min-width', '0', 'important'); b.style.setProperty('min-height', '0', 'important');
        b.style.setProperty('margin', '0', 'important'); b.style.setProperty('padding', '0', 'important');
      });
      // Kun hvis kurv-knap og ønskeliste står i en lille, ren beholder (ingen variantvælgere, felter eller valg),
      // får den 8 px luft. Ellers røres intet andet end selve ønskeliste-knappen.
      var BAD = 'select, input:not([type="hidden"]), fieldset, [class*="variant" i], [class*="option" i], [class*="swatch" i], [class*="picker" i]';
      var c = wl.parentElement, depth = 0;
      while (c && !c.contains(atc) && depth < 3) { c = c.parentElement; depth++; }
      if (c && c.contains(atc) && !c.querySelector(BAD) && c.children.length <= 4) {
        c.style.setProperty('display', 'flex', 'important');
        c.style.setProperty('align-items', 'center', 'important');
        c.style.setProperty('column-gap', '8px', 'important');
        var m = wl.parentElement;
        while (m && m !== c) {
          if (!m.querySelector(BAD)) { m.style.setProperty('flex', '0 0 auto', 'important'); m.style.setProperty('margin', '0', 'important'); m.style.setProperty('padding', '0', 'important'); }
          m = m.parentElement;
        }
      }
      soldOut(atc, wl, h);
    } finally { busy = false; }
  }
  /* Udsolgt: "Giv mig besked"-knappen (fx Klaviyo) fylder hele bredden ved siden af ønskelisten – samme højde, ingen ekstra luft */
  function soldOut(atc, wl, h) {
    var item = atc.closest('.product-form__item--submit') || atc.parentElement;
    if (!item) return;
    var out = atc.disabled || atc.offsetParent === null;
    item.classList.toggle('cl-is-soldout', !!out);
    if (!out) return;
    Array.prototype.forEach.call(item.children, function (ch) {
      if (ch === atc || (wl && (ch === wl || ch.contains(wl))) || (ch.matches && ch.matches(SEL)) || ch.classList.contains('cl-wl-ph') || /^(SCRIPT|STYLE)$/.test(ch.tagName)) return;
      if (!ch.offsetWidth && !ch.offsetHeight) return;
      ch.style.setProperty('flex', '1 1 auto', 'important');
      ch.style.setProperty('min-width', '0', 'important');
      ch.style.setProperty('width', 'auto', 'important');
      ch.style.setProperty('margin', '0', 'important');
      ch.style.setProperty('height', h + 'px', 'important');
      ch.querySelectorAll('button, a').forEach(function (b) {
        b.style.setProperty('width', '100%', 'important'); b.style.setProperty('height', '100%', 'important');
        b.style.setProperty('margin', '0', 'important'); b.style.setProperty('min-height', '0', 'important');
        b.style.setProperty('box-sizing', 'border-box', 'important');
      });
      if (ch.matches('button, a')) { ch.style.setProperty('padding', '0 16px', 'important'); ch.style.setProperty('box-sizing', 'border-box', 'important'); }
    });
  }
  /* Pladsholder: en sort, kvadratisk ønskeliste-knap vises med det samme, indtil appens rigtige knap er indlæst
     (appen henter sin knap 1–2 sek. efter siden). Fjernes, så snart den rigtige knap er der – eller efter 8 sek. */
  function addPh() {
    var atc = document.querySelector('.product-form button[name="add"]');
    if (!atc || document.querySelector('.cl-wl-ph')) return;
    var item = atc.closest('.product-form__item--submit');
    if (!item) return;
    var ph = document.createElement('span');
    ph.className = 'cl-wl-ph'; ph.setAttribute('aria-hidden', 'true');
    ph.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 3.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8-5.2-2.8-5.2 2.8 1-5.8-4.3-4.1 5.9-.9z"/></svg>';
    item.appendChild(ph);
    setTimeout(removePh, 8000);
  }
  function removePh() { document.querySelectorAll('.cl-wl-ph').forEach(function (e) { e.remove(); }); }
  function run() { addPh(); fix(); setTimeout(fix, 600); setTimeout(fix, 2000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('resize', function () { clearTimeout(window.__clWl); window.__clWl = setTimeout(fix, 150); });
  var n = 0;
  var mo = new MutationObserver(function () { if (++n > 200) return mo.disconnect(); clearTimeout(window.__clWl2); window.__clWl2 = setTimeout(fix, 100); });
  mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 15000);
})();
